import React from "react";
import PropTypes from "prop-types";

const TOTAL_STEPS = 5;

function PixAndGoStepper({ currentStep }) {
  return (
    <div className="flex items-center justify-center py-6">
      {Array.from({ length: TOTAL_STEPS }, (_, i) => {
        const step = i + 1;
        const isActive = step === currentStep;
        const isCompleted = step < currentStep;
        const isLast = step === TOTAL_STEPS;

        return (
          <React.Fragment key={step}>
            <div className="flex items-center justify-center">
              <div
                className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold border-2 transition-colors ${
                  isActive
                    ? "bg-pag-primary border-pag-primary text-pag-on-primary"
                    : isCompleted
                    ? "bg-pag-primary/60 border-pag-primary/60 text-pag-on-primary"
                    : "bg-transparent border-pag-on-background-muted text-pag-on-background-muted"
                }`}
              >
                {isCompleted ? "✓" : step}
              </div>
            </div>
            {!isLast && (
              <div
                className={`w-10 h-px transition-colors ${
                  step < currentStep
                    ? "bg-pag-primary/60"
                    : "bg-pag-on-background-muted opacity-50"
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

PixAndGoStepper.propTypes = {
  currentStep: PropTypes.number.isRequired,
};

export default PixAndGoStepper;
